module.exports = __webpack_public_path__ + "img/neo-app.24b8abf0.png";